import { render, staticRenderFns } from "./NhifInvoiceReport.vue?vue&type=template&id=661307e5&"
import script from "./NhifInvoiceReport.vue?vue&type=script&lang=js&"
export * from "./NhifInvoiceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports